import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import { Paper, Typography } from '@material-ui/core';
import { commonResourceStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';

const styles = commonResourceStyle();

class Zones extends Component {
  componentDidMount = () => {
    const {
      actions, apiToken, loading, locations, match,
    } = this.props;
    const { resource, subResource, resourceId } = match.params;

    if (loading === false) {
      if (!locations) {
        new Promise((resolve, reject) => {
          actions.getAllResources(apiToken, resource).then(() => actions.getAllResources(apiToken, resource, resourceId, subResource));
          resolve();
        }).catch();
      } else {
        const deliveryZones = this.retrieveItems();
        if (!deliveryZones) {
          actions.getAllResources(apiToken, resource, resourceId, subResource);
        }
      }
    }
  }

  componentDidUpdate = (prevProps) => {
    const {
      actions, apiToken, match, history,
    } = this.props;
    const { resource } = match.params;
    if (prevProps.apiToken !== apiToken && resource === 'locations') {
      history.push('/locations');
    }
  }

  retrieveItems = () => {
    const { locations, match } = this.props;
    const { resourceId } = match.params;
    const currentLocation = locations.find(location => location.id == resourceId);
    return currentLocation ? currentLocation.zones : [];
  }

  getTitle = subResource => (subResource === 'zones' ? 'Delivery Zones' : 'Catering Zones');

  render() {
    const {
      locations, actions, loading, apiToken, match,
    } = this.props;
    const { resource, subResource } = match.params;
    const { resourceId } = match.params;
    let zonesData = (locations && locations.length > 0) ? (locations.filter(loc => loc.id == resourceId)[0][subResource]) : [];
    zonesData = zonesData || [];

    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>{this.getTitle(subResource)}</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} />
              </div>
            </div>
            <Paper style={styles.paper}>
              <DisplayResources
                data={zonesData}
                actions={actions}
                fieldNames={resourceFields.zones}
                resourceName={subResource}
                apiToken={apiToken}
                locations={locations}
                match={match}
              />
            </Paper>
          </div>
        )
    );
  }
}

Zones.propTypes = {
  loading: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  apiToken: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

Zones.defaultProps = {
  locations: null,
};

export default withRouter(Zones);
